import { ref as f } from "vue";
function b(e) {
  const n = f("inline-label");
  function i(l) {
    l != null && `${l}`.length > 0 && (n.value = "floating-label");
  }
  const o = (l = !0) => {
    n.value !== "floating-label" && l && (n.value = "floating-label"), e("focusin");
  };
  function u(l) {
    if (l != null && `${l}`.trim().length > 0) {
      a(), e("focusout");
      return;
    }
    t();
  }
  const t = () => {
    n.value = "inline-label";
  }, a = () => {
    n.value = "floating-label";
  };
  return {
    labelState: n,
    setInitialLabelState: i,
    handleFocusIn: o,
    handleFocusOut: u,
    setInlineLabel: t,
    setFloatingLabel: a
  };
}
export {
  b as useFloatingLabel
};
